

import React, { useState, useEffect, useRef } from "react";
import cfg from '../../Config';


const COUNTRIES = [
    { code: "US", name: "United States" },
    { code: "AF", name: "Afghanistan" }, { code: "AL", name: "Albania" }, { code: "DZ", name: "Algeria" },
    { code: "AD", name: "Andorra" }, { code: "AO", name: "Angola" }, { code: "AR", name: "Argentina" },
    { code: "AM", name: "Armenia" }, { code: "AU", name: "Australia" }, { code: "AT", name: "Austria" },
    { code: "AZ", name: "Azerbaijan" }, { code: "BS", name: "Bahamas" }, { code: "BH", name: "Bahrain" },
    { code: "BD", name: "Bangladesh" }, { code: "BB", name: "Barbados" }, { code: "BY", name: "Belarus" },
    { code: "BE", name: "Belgium" }, { code: "BZ", name: "Belize" }, { code: "BJ", name: "Benin" },
    { code: "BT", name: "Bhutan" }, { code: "BO", name: "Bolivia" }, { code: "BA", name: "Bosnia and Herzegovina" },
    { code: "BW", name: "Botswana" }, { code: "BR", name: "Brazil" }, { code: "BN", name: "Brunei" },
    { code: "BG", name: "Bulgaria" }, { code: "BF", name: "Burkina Faso" }, { code: "BI", name: "Burundi" },
    { code: "KH", name: "Cambodia" }, { code: "CM", name: "Cameroon" }, { code: "CA", name: "Canada" },
    { code: "CV", name: "Cape Verde" }, { code: "CF", name: "Central African Republic" }, { code: "TD", name: "Chad" },
    { code: "CL", name: "Chile" }, { code: "CN", name: "China" }, { code: "CO", name: "Colombia" },
    { code: "KM", name: "Comoros" }, { code: "CG", name: "Congo" }, { code: "CR", name: "Costa Rica" },
    { code: "HR", name: "Croatia" }, { code: "CU", name: "Cuba" }, { code: "CY", name: "Cyprus" },
    { code: "CZ", name: "Czech Republic" }, { code: "DK", name: "Denmark" }, { code: "DJ", name: "Djibouti" },
    { code: "DM", name: "Dominica" }, { code: "DO", name: "Dominican Republic" }, { code: "EC", name: "Ecuador" },
    { code: "EG", name: "Egypt" }, { code: "SV", name: "El Salvador" }, { code: "GQ", name: "Equatorial Guinea" },
    { code: "ER", name: "Eritrea" }, { code: "EE", name: "Estonia" }, { code: "SZ", name: "Eswatini" },
    { code: "ET", name: "Ethiopia" }, { code: "FJ", name: "Fiji" }, { code: "FI", name: "Finland" },
    { code: "FR", name: "France" }, { code: "GA", name: "Gabon" }, { code: "GM", name: "Gambia" },
    { code: "GE", name: "Georgia" }, { code: "DE", name: "Germany" }, { code: "GH", name: "Ghana" },
    { code: "GR", name: "Greece" }, { code: "GD", name: "Grenada" }, { code: "GT", name: "Guatemala" },
    { code: "GN", name: "Guinea" }, { code: "GW", name: "Guinea-Bissau" }, { code: "GY", name: "Guyana" },
    { code: "HT", name: "Haiti" }, { code: "HN", name: "Honduras" }, { code: "HU", name: "Hungary" },
    { code: "IS", name: "Iceland" }, { code: "IN", name: "India" }, { code: "ID", name: "Indonesia" },
    { code: "IR", name: "Iran" }, { code: "IQ", name: "Iraq" }, { code: "IE", name: "Ireland" },
    { code: "IL", name: "Israel" }, { code: "IT", name: "Italy" }, { code: "CI", name: "Ivory Coast" },
    { code: "JM", name: "Jamaica" }, { code: "JP", name: "Japan" }, { code: "JO", name: "Jordan" },
    { code: "KZ", name: "Kazakhstan" }, { code: "KE", name: "Kenya" }, { code: "KI", name: "Kiribati" },
    { code: "XK", name: "Kosovo" }, { code: "KW", name: "Kuwait" }, { code: "KG", name: "Kyrgyzstan" },
    { code: "LA", name: "Laos" }, { code: "LV", name: "Latvia" }, { code: "LB", name: "Lebanon" },
    { code: "LS", name: "Lesotho" }, { code: "LR", name: "Liberia" }, { code: "LY", name: "Libya" },
    { code: "LI", name: "Liechtenstein" }, { code: "LT", name: "Lithuania" }, { code: "LU", name: "Luxembourg" },
    { code: "MG", name: "Madagascar" }, { code: "MW", name: "Malawi" }, { code: "MY", name: "Malaysia" },
    { code: "MV", name: "Maldives" }, { code: "ML", name: "Mali" }, { code: "MT", name: "Malta" },
    { code: "MH", name: "Marshall Islands" }, { code: "MR", name: "Mauritania" }, { code: "MU", name: "Mauritius" },
    { code: "MX", name: "Mexico" }, { code: "FM", name: "Micronesia" }, { code: "MD", name: "Moldova" },
    { code: "MC", name: "Monaco" }, { code: "MN", name: "Mongolia" }, { code: "ME", name: "Montenegro" },
    { code: "MA", name: "Morocco" }, { code: "MZ", name: "Mozambique" }, { code: "MM", name: "Myanmar" },
    { code: "NA", name: "Namibia" }, { code: "NR", name: "Nauru" }, { code: "NP", name: "Nepal" },
    { code: "NL", name: "Netherlands" }, { code: "NZ", name: "New Zealand" }, { code: "NI", name: "Nicaragua" },
    { code: "NE", name: "Niger" }, { code: "NG", name: "Nigeria" }, { code: "KP", name: "North Korea" },
    { code: "MK", name: "North Macedonia" }, { code: "NO", name: "Norway" }, { code: "OM", name: "Oman" },
    { code: "PK", name: "Pakistan" }, { code: "PW", name: "Palau" }, { code: "PA", name: "Panama" },
    { code: "PG", name: "Papua New Guinea" }, { code: "PY", name: "Paraguay" }, { code: "PE", name: "Peru" },
    { code: "PH", name: "Philippines" }, { code: "PL", name: "Poland" }, { code: "PT", name: "Portugal" },
    { code: "QA", name: "Qatar" }, { code: "RO", name: "Romania" }, { code: "RU", name: "Russia" },
    { code: "RW", name: "Rwanda" }, { code: "KN", name: "Saint Kitts and Nevis" }, { code: "LC", name: "Saint Lucia" },
    { code: "VC", name: "Saint Vincent and the Grenadines" }, { code: "WS", name: "Samoa" }, { code: "SM", name: "San Marino" },
    { code: "ST", name: "Sao Tome and Principe" }, { code: "SA", name: "Saudi Arabia" }, { code: "SN", name: "Senegal" },
    { code: "RS", name: "Serbia" }, { code: "SC", name: "Seychelles" }, { code: "SL", name: "Sierra Leone" },
    { code: "SG", name: "Singapore" }, { code: "SK", name: "Slovakia" }, { code: "SI", name: "Slovenia" },
    { code: "SB", name: "Solomon Islands" }, { code: "SO", name: "Somalia" }, { code: "ZA", name: "South Africa" },
    { code: "KR", name: "South Korea" }, { code: "SS", name: "South Sudan" }, { code: "ES", name: "Spain" },
    { code: "LK", name: "Sri Lanka" }, { code: "SD", name: "Sudan" }, { code: "SR", name: "Suriname" },
    { code: "SE", name: "Sweden" }, { code: "CH", name: "Switzerland" }, { code: "SY", name: "Syria" },
    { code: "TW", name: "Taiwan" }, { code: "TJ", name: "Tajikistan" }, { code: "TZ", name: "Tanzania" },
    { code: "TH", name: "Thailand" }, { code: "TL", name: "Timor-Leste" }, { code: "TG", name: "Togo" },
    { code: "TO", name: "Tonga" }, { code: "TT", name: "Trinidad and Tobago" }, { code: "TN", name: "Tunisia" },
    { code: "TR", name: "Turkey" }, { code: "TM", name: "Turkmenistan" }, { code: "TV", name: "Tuvalu" },
    { code: "UG", name: "Uganda" }, { code: "UA", name: "Ukraine" }, { code: "AE", name: "United Arab Emirates" },
    { code: "GB", name: "United Kingdom" }, { code: "UY", name: "Uruguay" }, { code: "UZ", name: "Uzbekistan" },
    { code: "VU", name: "Vanuatu" }, { code: "VA", name: "Vatican City" }, { code: "VE", name: "Venezuela" },
    { code: "VN", name: "Vietnam" }, { code: "YE", name: "Yemen" }, { code: "ZM", name: "Zambia" },
    { code: "ZW", name: "Zimbabwe" },
];

let googleMapsScriptPromise = null;

function loadGoogleMapsPlaces(apiKey) {
    if (!apiKey) {
        return Promise.reject(new Error("Google Places API key is not configured yet."));
    }
    if (window.google && window.google.maps && window.google.maps.places) {
        return Promise.resolve(window.google);
    }
    if (googleMapsScriptPromise) {
        return googleMapsScriptPromise;
    }
    googleMapsScriptPromise = new Promise((resolve, reject) => {
        const callbackName = "__initGooglePlacesAutocomplete";
        window[callbackName] = () => {
            delete window[callbackName];
            resolve(window.google);
        };
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=places&callback=${callbackName}`;
        script.async = true;
        script.defer = true;
        script.onerror = () => {
            googleMapsScriptPromise = null;
            reject(new Error("Failed to load Google Maps Places script."));
        };
        document.head.appendChild(script);
    });
    return googleMapsScriptPromise;
}

function parseGooglePlaceAddress(place) {
    const components = (place && place.address_components) || [];
    const getComponent = (type, useShortName) => {
        const component = components.find((c) => c.types.includes(type));
        return component ? (useShortName ? component.short_name : component.long_name) : "";
    };

    const streetNumber = getComponent("street_number");
    const route = getComponent("route");
    const city = getComponent("locality") || getComponent("sublocality") || getComponent("administrative_area_level_2");
    const state = getComponent("administrative_area_level_1", true);
    const zipCode = getComponent("postal_code");
    const country = getComponent("country", true);

    return {
        addressLine1: [streetNumber, route].filter(Boolean).join(" "),
        city,
        state,
        zipCode,
        country,
    };
}

export default function ShippingDetailsComponent({ shippingDetails, setShippingDetails, errors, includePhone = false, requirePhone = false }) {

    const [touched, setTouched] = useState({});
    const addressLine1Ref = useRef(null);
    const autocompleteRef = useRef(null);

    useEffect(() => {
        const apiKey = cfg.googlePlaces && cfg.googlePlaces.apiKey;
        if (!apiKey || !addressLine1Ref.current) {
            return;
        }

        let isMounted = true;
        loadGoogleMapsPlaces(apiKey)
            .then((google) => {
                if (!isMounted || !addressLine1Ref.current) {
                    return;
                }
                autocompleteRef.current = new google.maps.places.Autocomplete(addressLine1Ref.current, {
                    types: ["address"],
                    fields: ["address_components"],
                });
                autocompleteRef.current.addListener("place_changed", () => {
                    const place = autocompleteRef.current.getPlace();
                    const parsed = parseGooglePlaceAddress(place);
                    setShippingDetails((prev) => ({ ...prev, ...parsed }));
                });
            })
            .catch((ex) => {
                // Address autocomplete is an enhancement; fall back to plain manual entry.
                console.error("Google Places Autocomplete unavailable", ex);
            });

        return () => {
            isMounted = false;
            if (autocompleteRef.current && window.google) {
                window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
            }
        };
    }, []);

    function handleShippingDetailsChange(field) {
        return (e) => {
            const value = e.target.value;
            setShippingDetails((prev) => ({ ...prev, [field]: value }));
        };
    }

    function handleShippingDetailsBlur(field) {
        return () => {
            setTouched((prev) => ({ ...prev, [field]: true }));
        };
    }

    function fieldClass(field) {
        return "form-control" + (touched[field] && errors[field] ? " is-invalid" : "");
    }

    function fieldError(field) {
        return touched[field] && errors[field] ? <div className="invalid-feedback text-start">{errors[field]}</div> : null;
    }

    return (
        <>
            <div className="head-line">
                <p className="headline-consent-text">Where Should We Send Your FREE Book?</p>
            </div>
            <div class="row gap-3 mt-4 align-items-start text-center mb-4">
                <div class="border rounded col-3 p-0 bg-body options-box mx-auto">
                    <div className="p-2">
                        <label class="text-start fw-bold">Shipping Details</label>
                    </div>
                    <div class="text-start">
                        <div class="p-2">
                            <div class="input-group p-1">
                                <div class="flex-fill">
                                    <input type="text" required maxLength={100} class={fieldClass('firstName')} placeholder="First Name" value={shippingDetails.firstName} onChange={handleShippingDetailsChange('firstName')} onBlur={handleShippingDetailsBlur('firstName')} />
                                    {fieldError('firstName')}
                                </div>
                            </div>
                            <div class="input-group p-1">
                                <div class="flex-fill">
                                    <input type="text" required maxLength={100} class={fieldClass('lastName')} placeholder="Last Name" value={shippingDetails.lastName} onChange={handleShippingDetailsChange('lastName')} onBlur={handleShippingDetailsBlur('lastName')} />
                                    {fieldError('lastName')}
                                </div>
                            </div>
                            <div class="input-group p-1">
                                <div class="flex-fill">
                                    <input type="text" required maxLength={100} ref={addressLine1Ref} autoComplete="off" class={fieldClass('addressLine1')} placeholder="Address Line" value={shippingDetails.addressLine1} onChange={handleShippingDetailsChange('addressLine1')} onBlur={handleShippingDetailsBlur('addressLine1')} />
                                    {fieldError('addressLine1')}
                                </div>
                            </div>
                            <div class="input-group p-1">
                                <input type="text" maxLength={100} class="form-control" placeholder="Address Line 2" value={shippingDetails.addressLine2} onChange={handleShippingDetailsChange('addressLine2')} />
                            </div>
                            <div class="input-group p-1">
                                <div class="flex-fill">
                                    <input type="text" required maxLength={50} class={fieldClass('city')} placeholder="City" value={shippingDetails.city} onChange={handleShippingDetailsChange('city')} onBlur={handleShippingDetailsBlur('city')} />
                                    {fieldError('city')}
                                </div>
                            </div>
                            <div class="input-group p-1">
                                <div class="flex-fill">
                                    <input type="text" required maxLength={50} class={fieldClass('state')} placeholder="State" value={shippingDetails.state} onChange={handleShippingDetailsChange('state')} onBlur={handleShippingDetailsBlur('state')} />
                                    {fieldError('state')}
                                </div>
                            </div>
                            <div class="input-group p-1">
                                <div class="flex-fill">
                                    <input type="text" required maxLength={12} class={fieldClass('zipCode')} placeholder="Zip Code" value={shippingDetails.zipCode} onChange={handleShippingDetailsChange('zipCode')} onBlur={handleShippingDetailsBlur('zipCode')} />
                                    {fieldError('zipCode')}
                                </div>
                            </div>
                            <div class="input-group p-1">
                                <div class="flex-fill">
                                    <select required class={`${fieldClass('country')} form-control-sm`} value={shippingDetails.country} onChange={handleShippingDetailsChange('country')} onBlur={handleShippingDetailsBlur('country')}>
                                        <option value="">Select Country</option>
                                        {COUNTRIES.map((country) => <option key={country.code} value={country.code}>{country.name}</option>)}
                                    </select>
                                    {fieldError('country')}
                                </div>
                            </div>

                            {includePhone && (
                                <div class="input-group p-1">
                                    <div class="flex-fill">
                                        <input type="tel" required={requirePhone} class={fieldClass('phone')} placeholder={requirePhone ? "Best daytime phone number" : "Best daytime phone number (optional)"} value={shippingDetails.phone} onChange={handleShippingDetailsChange('phone')} onBlur={handleShippingDetailsBlur('phone')} />
                                        {fieldError('phone')}
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}